import { render, staticRenderFns } from "./DisplayItem.vue?vue&type=template&id=6268d5c4&scoped=true"
import script from "./DisplayItem.vue?vue&type=script&lang=js"
export * from "./DisplayItem.vue?vue&type=script&lang=js"
import style0 from "./DisplayItem.vue?vue&type=style&index=0&id=6268d5c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6268d5c4",
  null
  
)

export default component.exports